　<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'予約施設情報' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'追加' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field" fxLayout="row" fxLayoutGap="20px">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
  <mat-form-field fxFlex="15%">
    <mat-select placeholder="{{'属性' | translate}}" id="reservationFacilityAttributeId" (selectionChange)="applyFilterAttr($event)">
      <mat-option [value]= ""></mat-option>
      <mat-option *ngFor="let reservationFacilityAttribute of reservationFacilityAttributes" [value]="reservationFacilityAttribute.attribute_id">
        {{ reservationFacilityAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let reservationFacility; let i = index"> {{ (i + 1) + (paginator.pageSize *
        paginator.pageIndex) }} </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef> {{'編集' | translate}} </th>
      <td mat-cell *matCellDef="let reservationFacility">
        <button mat-button color="primary" (click)="openEditDialog(reservationFacility)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox color="warn" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="reservation_facility_id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> ID </th>
      <td mat-cell *matCellDef="let reservationFacility"> {{reservationFacility.reservation_facility_id}} </td>
    </ng-container>

    <ng-container matColumnDef="attribute">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'属性' | translate}} </th>
      <td mat-cell *matCellDef="let reservationFacility">
        <span
          *ngFor="let attribute of (reservationFacility.reservation_facility_attribute_id | docsByCond:attrCollectionName:'attribute_id' | async)">
          {{ attribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'名称' | translate}} </th>
      <td mat-cell *matCellDef="let reservationFacility"> {{ reservationFacility.reservation_facility_names |
        multiName:projectLanguages:projectBaseLang }} </td>
    </ng-container>

    <ng-container matColumnDef="file">
      <th mat-header-cell *matHeaderCellDef> {{'画像' | translate}} </th>
      <td mat-cell *matCellDef="let reservationFacility">
        <img *ngIf="!!reservationFacility.reservation_facility_files[0]"
          [src]="(reservationFacility.reservation_facility_files[0].file_id | doc:uploadedFilesCollectionName | async)?.download_url"
          height="40px" width="auto">
      </td>
    </ng-container>

    <ng-container matColumnDef="reservation">
      <th mat-header-cell *matHeaderCellDef> {{'予約状況' | translate}} </th>
      <td mat-cell *matCellDef="let reservationFacility">
        <button mat-button color="primary" (click)="openReservationDialog(reservationFacility)">
          <mat-icon>today</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'更新日時' | translate}}
      </th>
      <td mat-cell *matCellDef="let reservationFacility"> {{ reservationFacility.updated.toDate() | date: 'yyyy/MM/dd
        HH:mm:ss' }} </td>
    </ng-container>

    <ng-container matColumnDef="special">
      <th mat-header-cell *matHeaderCellDef> {{'特別営業日' | translate}} </th>
      <td mat-cell *matCellDef="let reservationFacility">
        <button mat-raised-button
          (click)="selectReservationFacility(reservationFacility.reservation_facility_id, reservationFacility.reservation_unit)">
          <span>{{'設定へ' | translate}}</span>
          <mat-icon>forward</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>